<script>
import countTo from 'vue-count-to'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Money from '@src/mixins/money'
import moment from 'moment'
import DashboardService from '@services/resources/DashboardService'
var service = DashboardService.build();

/**
 * Dashboard-1 Component
 */
export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { countTo, Layout },
  mixins:[Money],
  data() {
    return {
      widgetData: [],
      salesMixedChart: {
        series: [
          {
            name: '',
            type: 'column',
            data: []
          }
        ]
      },
      revenueRadialChart: [],
      topSellers: [],
      lastSales: [],
      totalRevenueLastMonth: 0,
      title: 'Dashboard',
      items: [
        {
          text: 'Ubold',
          href: '/',
        },
        {
          text: 'Dashboard',
          active: true,
        },
      ],
      state: {
        date: new Date(),
      },
    }
  },
  mounted(){
    this.fetchData();
  },
  methods:{
    fetchData(){

      service
        .search()
        .then(resp => {

          this.widgetData = [
            {
              icon: 'fe-heart',
              color: 'primary',
              value: resp.salesTotal,
              text: 'Total de vendas'
            },
            {
              icon: 'fe-shopping-cart',
              color: 'success',
              value: resp.salesToday,
              text: "Vendas de hoje"
            },
            {
              icon: 'fe-bar-chart-line-',
              color: 'info',
              value: resp.salesLastWeek,
              text: 'Vendas da última semana'
            }
          ];

          this.topSellers = resp.topSellers;
          this.lastSales = resp.lastSales;

          // Radial chart
          this.totalRevenueLastMonth = resp.salesLastMonth;
          var target = 10000;
          var percent = (1 - ((target - this.totalRevenueLastMonth) / target)) * 100;
          this.revenueRadialChart = {
            series: [percent],
            chartOptions: {
                chart: {
                    toolbar: {
                        show: false,
                    },
                },
                stroke: {
                    lineCap: 'round',
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            size: '65%',
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                formatter: function (val) {
                                    return parseInt(val)
                                },
                                fontSize: '24px',
                                offsetY: 10,
                                color: 'rgb(241, 85, 108)',
                            },
                        },
                    },
                },
                colors: ['rgb(241, 85, 108)'],
            }
          }



          // Bar chart
          let data = [];
          let labels = [];
          resp.lastWeekSalesDetails.forEach(element => {
            data.push(element.amount.toFixed(2));
            labels.push(moment(element.day, 'YYYY-MM-DD').format('DD/MM/YYYY'));
          });

          this.salesMixedChart = {
            series:[
              {
                name: 'Vendas',
                type: 'column',
                data: data
              }
            ],
            chartOptions: {
              chart: {
                  padding: {
                      right: 0,
                      left: 0
                  },
                  stacked: false,
                  toolbar: {
                      show: false
                  }
              },
              colors: ['#1abc9c'],

              plotOptions: {
                  bar: {
                      columnWidth: '50%'
                  }
              },
              fill: {
                  opacity: [0.85, 0.25, 1],
                  gradient: {
                      inverseColors: false,
                      shade: 'light',
                      type: 'vertical',
                      opacityFrom: 0.85,
                      opacityTo: 0.55,
                      stops: [0, 100, 100, 100]
                  }
              },
              labels: labels,
              markers: {
                  size: 0
              },
              legend: {
                  show: false
              },
              xaxis: {
                  type: 'date',
                  axisBorder: {
                      show: false
                  },
                  axisTicks: {
                      show: false
                  }
              },
              yaxis: {
                  title: {
                      text: '',
                  },
              },
              tooltip: {
                  shared: true,
                  followCursor: true,
                  intersect: false,
                  y: {
                      formatter(y) {
                          if (typeof y !== 'undefined') {
                              return y.toFixed(0) + ' points';
                          }
                          return y;
                      }
                  }
              },
              grid: {
                  borderColor: '#f1f3fa'
              }
          }
          }

        }).catch(err => {
          console.log(err);
        });

    }
  }
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <h4 class="page-title">Dashboard </h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div v-for="widget in widgetData" :key="widget.value" class="col-md-6 col-xl-4">
        <div class="widget-rounded-circle card-box">
          <div class="row">
            <div class="col-4">
              <div
                :class="`avatar-lg rounded-circle bg-soft-${widget.color} border-${widget.color} border`"
              >
                <i :class="`${ widget.icon } font-22 avatar-title text-${ widget.color}`"></i>
              </div>
            </div>
            <div class="col-8">
              <div class="text-right">
                <h3 class="text-dark mt-1">
                  <span>
                    R$ <countTo :end-val="widget.value" separator="." decimal="," :decimals="2" :duration="3000"></countTo>
                  </span>
                </h3>
                <p class="text-muted mb-1 text-truncate">{{ widget.text }}</p>
              </div>
            </div>
          </div>
          <!-- end row-->
        </div>
        <!-- end widget-rounded-circle-->
      </div>
      <!-- end col-->
    </div>
    <div class="row">
      <div class="col-xl-4">
        <div class="card-box">
          <h4 class="header-title mb-1">Vendas último mês</h4>
          <div class="widget-chart text-center" dir="ltr">
            <apexchart
              type="radialBar"
              height="200"
              :options="revenueRadialChart.chartOptions"
              :series="revenueRadialChart.series"
            ></apexchart>
            <h5 class="text-muted">Total de vendas no último mês</h5>
            <h2>R$ {{ formatMoney(totalRevenueLastMonth, 2, ',') }}</h2>

            <!-- <div class="row mt-3">
              <div class="col-4">
                <p class="text-muted font-15 mb-1 text-truncate">Target</p>
                <h4>
                  <i class="fe-arrow-down text-danger mr-1"></i>$7.8k
                </h4>
              </div>
              <div class="col-4">
                <p class="text-muted font-15 mb-1 text-truncate">Last week</p>
                <h4>
                  <i class="fe-arrow-up text-success mr-1"></i>$1.4k
                </h4>
              </div>
              <div class="col-4">
                <p class="text-muted font-15 mb-1 text-truncate">Last Month</p>
                <h4>
                  <i class="fe-arrow-down text-danger mr-1"></i>$15k
                </h4>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="col-xl-8">
        <div class="card-box">
          <h4 class="header-title mb-3">Última semana de vendas</h4>
          <!-- sales analytics chart -->
          <div style="height: 230px;">
            <apexchart
              height="225"
              type="bar"
              :options="salesMixedChart.chartOptions"
              :series="salesMixedChart.series"
            ></apexchart>
          </div>
          <!-- end chart -->
        </div>
        <!-- end card-box -->
      </div>
      <!-- end col-->
    </div>
    <div class="row">
      <div class="col-xl-6">
        <div class="card-box">
          <h4 class="header-title mb-3">Top 5 vendedores</h4>

          <div class="table-responsive mb-0">
            <b-table-simple class="table table-borderless table-hover table-centered m-0">
              <b-thead class="thead-light">
                <b-tr>
                  <b-th>Nome</b-th>
                  <b-th>Valor</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="item in topSellers" :key="item.name">
                  <b-td>
                    <h5 class="m-0 font-weight-normal">{{ item.seller.name }}</h5>
                  </b-td>
                  <b-td>R$ {{ formatMoney(item.amount, 2, ',') }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="card-box">
          <h4 class="header-title mb-3">Últimas vendas</h4>
          <div class="table-responsive mb-0">
            <table class="table table-borderless table-hover table-centered m-0">
              <thead class="thead-light">
                <tr>
                  <th>Produto</th>
                  <th>Valor</th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in lastSales" :key="item.id">
                  <td>{{ item.product.name }}</td>
                  <td>R$ {{ formatMoney(item.total, 2, ',') }}</td>
                  <td>{{ item.created_at | datetime }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- end .table-responsive-->
        </div>
      </div>
    </div>
  </Layout>
</template>
